import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';

const Callback: React.FC = () => {
  const { isLoading, isAuthenticated, error } = useAuth0();

  useEffect(() => {
    // Log any errors for debugging
    if (error) {
      console.error('Auth0 callback error:', error);
    }
  }, [error]);

  if (error) {
    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
        <Typography color="error" variant="h6" gutterBottom>
          Authentication Error
        </Typography>
        <Typography variant="body1">
          {error.message}
        </Typography>
      </Box>
    );
  }

  if (!isLoading && isAuthenticated) {
    return <Navigate to="/order-fulfillment/operations-dashboard" replace />;
  }

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default Callback;